import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getDataUser } from "../../RTK/Slice/Auth/AuthSlice";

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useSelector(getDataUser) ;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;